// Fill gestures use nail coordinates, just like the persisted stroke points.
// Requiring a return to the visible starting ring avoids the unexpected long
// diagonal that SVG adds when an arbitrary open scribble is filled.
export const FILL_CLOSE_RADIUS=5;
const finitePoint=point=>point&&Number.isFinite(point.x)&&Number.isFinite(point.y);

export function fillStrokeReady(layer){
  const points=layer?.points;
  if(layer?.brush!=='fill'||!Array.isArray(points)||points.length<4||!points.every(finitePoint))return false;
  const first=points[0],last=points.at(-1);
  if(Math.hypot(first.x-last.x,first.y-last.y)>FILL_CLOSE_RADIUS)return false;
  let area=0;
  for(let i=0,j=points.length-1;i<points.length;j=i++)area+=points[j].x*points[i].y-points[i].x*points[j].y;
  return Math.abs(area)>=8;
}

export function finalizeFillStroke(layer){
  if(layer?.brush!=='fill')return layer;
  if(!fillStrokeReady(layer))return null;
  const points=layer.points.map(point=>({...point})),first=points[0],last=points.at(-1);
  // Snap a near miss to the same start used by the preview. Keep the existing
  // 1,200 point budget so saving/reloading cannot lose the closing segment.
  if(last.x!==first.x||last.y!==first.y){
    if(points.length>=1200)points[points.length-1]={...first};
    else points.push({...first});
  }
  return{...layer,points,fillClosed:true,taper:false};
}

export function isFilledStroke(layer){
  return layer?.brush==='fill'&&layer.fillClosed!==false;
}
